import React from 'react';

import { IItem } from 'api/catalog/models';
import ImageCarousel from 'ui/ImageCarousel';

interface IProps {
  assets: IItem['assets'];
}

const ProductImage = ({ assets }: IProps) => {
  return <ImageCarousel assets={assets} />;
};

export default ProductImage;
